import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Material Dashboard Components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

// MUI
import { Card, Dialog, DialogContent, DialogTitle, Grid, Icon, IconButton, Switch, TextField, Tooltip } from "@mui/material";
 
import {deleteVersion, getVersionList, saveVersion, updateVersion} from '../../../actions/version'
import DataTable from "../../../examples/Tables/DataTable/serverTable";
import {
    get as _get,
    map as _map,
    omit as _omit,
    isEmpty as _isEmpty,
  } from "lodash";
  import * as Yup from "yup";
import pxToRem from "../../../assets/theme/functions/pxToRem";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Formik } from "formik";

const VersionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [editId, setEditId] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [initialValues, setInitialValues] = useState({
    version: "",
    text: "",
    isForceUpdate: false,
  });
  const storeProps = useSelector((state) => ({
    data: _get(state, "version.versionList", []),
  }));

  // Validation schema
  const schema = Yup.object().shape({
    version: Yup.string().required("Version is required"),
    text: Yup.string()
    .max(100, "Message must be at most 100 characters")
    .required("Description is required"),
  });
  const handleClickOpen = (item) => {
    if (item) {
      setInitialValues({
        version: item.version || "",
        text: item.text || "",
        isForceUpdate: item.isForceUpdate ?? false
      });
      setEditId(item._id);
      setIsNew(false);
    } else {
      setInitialValues({
        version: "",
        text: "",
        isForceUpdate: false,
      });
      setIsNew(true);
    }
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsNew(false);
    setInitialValues({
      version: "",
      text: "",
      isForceUpdate: false,
    });
  };

  const handleSubmit = (values) => {
    if (isNew) {
      dispatch(saveVersion(values));
    } else {
      dispatch(updateVersion({ _id: editId, ...values }));
    }

    handleClose();
  };

  const handleConfirmationClose = () => {
    setOpenConfirmation(false);
    setDeleteId("");
  };

  const handleDelete = (id) => {
    if (!id) return;
  
    dispatch(deleteVersion(id)); // ✅ send string only
    handleConfirmationClose();
  };

//   const handleStatusChange = (value, key) => {
//     dispatch(updateVersionStatus({ _id: key, isForceUpdate: value }));
//   };
  const tableData = {
    columns: [
      {
        Header: "Version",
        accessor: "version",
        Cell: (row) => (
          <Tooltip title={_get(row, "row.original.version")}>
            <MDTypography fontSize="14px">
              {_get(row, "row.original.version")}
            </MDTypography>
          </Tooltip>
        ),
        align: "left",
      },
      {
        Header: "Message",
        accessor: "text",
        Cell: (row) => (
          <Tooltip title={_get(row, "row.original.text")}>
            <MDTypography fontSize="14px">
              {_get(row, "row.original.text")}
            </MDTypography>
          </Tooltip>
        ),
        align: "left",
        width: "30%",
      },
      {
        Header: "Force Update",
        accessor: "isForceUpdate",
        Cell: (row) => {
          const value = _get(row, "row.original.isForceUpdate");
      
          return (
            <MDTypography
              fontSize="14px"
              color={value ? "success" : "text"}
              fontWeight="medium"
            >
              {value ? "True" : "False"}
            </MDTypography>
          );
        },
        align: "center",
        width: "10%",
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (row) => (
          <MDBox width="100px" margin="auto">
            <IconButton
              sx={{
                color: "#54AF3A",
                backgroundColor: "#E8FFE2",
                borderRadius: "6px",
                width: pxToRem(35),
                height: pxToRem(35),
                "&:hover": { backgroundColor: "#e6f3e2" },
              }}
              onClick={() => handleClickOpen(_get(row, "row.original"))}
            >
              <Icon fontSize="small">edit_icon</Icon>
            </IconButton>

       
          </MDBox>
        ),
        align: "center",
        width: "10%",
      },
    ],
    rows: Array.isArray(storeProps.data) ? storeProps.data : [],
  };

  const { columns, rows } = tableData;
  const versionList = useSelector((state) => {
    console.log("Redux State:", state);
    return state.version.versionList || [];
  });

  useEffect(() => {
    dispatch(getVersionList());
  }, [dispatch]);

  return (

      <MDBox pt={0} >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={0}
                mt={0}
                py={3}
                px={2}
                mb={0}
                variant="contained"
                bgColor="rgba(0, 0, 0, 0.0)"
                borderRadius="lg"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={2}
              >
                <MDTypography variant="h5" color="black">
                  App Version List
                </MDTypography>
              </MDBox>
            <MDBox>
            <DataTable
            table={{ columns, rows }}
            isSorted={false}
            showTotalEntries={false}
            noEndBorder
            tableFor="versionList"
          />
              </MDBox>
              <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
  <DialogTitle sx={{ m: 0, pr: 8 }}>
    {isNew ? "Add Version" : "Edit Version"}
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 10,
        color: (theme) => theme.palette.grey[700],
        backgroundColor: (theme) => theme.palette.grey[200],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, setFieldValue  }) => (
        <Form>
          <TextField
            label="Version"
            name="version"
            fullWidth
            value={values.version}
            onChange={(e) => setFieldValue("version", e.target.value)}
            margin="normal"
            error={touched.version && Boolean(errors.version)}
            helperText={touched.version && errors.version}
          />

          <TextField
            label="Message"
            name="text"
            fullWidth
            value={values.text}
            onChange={(e) => setFieldValue("text", e.target.value)}
            margin="normal"
            multiline
            rows={3}
            inputProps={{ maxLength: 100 }} 
            error={touched.text && Boolean(errors.text)}
            helperText={touched.text && errors.text}
          />

          <MDBox mt={2} display="flex" alignItems="center">
            <MDTypography mr={1}>Force Update</MDTypography>
            <Switch
              name="isForceUpdate"
              checked={values.isForceUpdate}
              onChange={(e) =>
                setFieldValue("isForceUpdate", e.target.checked)
              }
            />
          </MDBox>
      

          <MDBox mt={3}>
            <MDButton
              variant="outlined"
              color="success"
              type="submit"
              sx={{ mr: 2 }}
            >
              Save
            </MDButton>
            <MDButton
              variant="outlined"
              color="error"
              onClick={handleClose}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Form>
      )}
    </Formik>
  </DialogContent>
</Dialog>
<Dialog
  open={openConfirmation}
  onClose={handleConfirmationClose}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <MDTypography>
      Are you sure you want to delete this version?
    </MDTypography>

    <MDBox mt={3} display="flex" justifyContent="flex-end">
      <MDButton
        variant="outlined"
        color="error"
        onClick={() => handleDelete(deleteId)}
        sx={{ mr: 2 }}
      >
        Delete
      </MDButton>

      <MDButton
        variant="outlined"
        color="secondary"
        onClick={handleConfirmationClose}
      >
        Cancel
      </MDButton>
    </MDBox>
  </DialogContent>
</Dialog>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
  );
};

export default VersionList;
